<div class="loadingspinner" *ngIf="isLoading" [ngClass]="loadingClass" [style.z-index]="loadingLevel">
    <div *ngIf="show">
        <spinner></spinner>
    </div>
</div>
<ng-content></ng-content>